<template>
    <div class="container box-like">
        <div class="illu" @mousemove="onMouseMove" @mouseout="() => {blurRadius = 0; translateX = 0; translateY = 0}">
            <div class="clock" :style="{filter: `blur(${blurRadius}px)`, transform: `translate(${translateX}px, ${translateY}px)`}">
                <div class="h-ring"></div>
                <div class="m-ring"></div>
                <div class="s-ring"></div>
                <div
                    class="hour"
                    :style="{transform: `rotateZ(${hDeg}deg) translateY(-260px)`}"
                >
                    <div :style="{transform: `rotateZ(${-hDeg}deg)`}">{{hIcon}}</div>
                </div>
                <div
                    class="minute"
                    :style="{transform: `rotateZ(${mDeg}deg) translateY(-320px)`}"
                ></div>
                <div
                    class="second"
                    :style="{transform: `rotateZ(${sDeg}deg) translateY(-380px)`}"
                ></div>
                <div class="username">{{userInfo.uname}}<br />欢迎登录锡盟燃气</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapMutations, mapState
} from 'vuex'

export default {
    name: 'index',
    computed: {
        ...mapState('stored', ['userInfo'])
    },
    data() {
        return {
            hDeg: 0,
            mDeg: 0,
            sDeg: 0,
            hIcon: true,
            blurRadius: 0,
            translateX: 0,
            translateY: 0
        }
    },
    components: {

    },
    mounted() {
        let updateTime = () => {
            let { hour, minute, second } = this.$util.tool.dateTransform()
            this.hDeg = hour % 12 * 30 + minute * 0.5 + second / 120
            this.mDeg = minute * 6 + second * 0.1
            this.sDeg = second * 6
            this.hIcon = hour >= 0 && hour <= 12 ? 'AM' : 'PM'
        }
        updateTime()
        setInterval(updateTime, 1000)
    },
    methods: {
        ...mapMutations('global', ['setLoading']),
        onMouseMove(e) {
            let x = Math.abs(e.movementX)
            let y = Math.abs(e.movementY)
            this.translateX = x / 80
            this.translateY = y / 80
            this.blurRadius = Math.max(x, y) / 150
        }
    }
}
</script>

<style scoped lang="less">
@import "./index.less";
</style>
